export default "__VITE_ASSET__DwDWmPjY__"